import { render, staticRenderFns } from "./GatNumEdit.vue?vue&type=template&id=1cdb6570&scoped=true&"
import script from "./GatNumEdit.vue?vue&type=script&lang=js&"
export * from "./GatNumEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdb6570",
  null
  
)

export default component.exports